// Дзеркало Prisma enum Parity. Парність тижня (D8): непарний тиждень семестру — чисельник (ODD), парний — знаменник (EVEN).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const Parity = {
    ALL: 'ALL',
    ODD: 'ODD',
    EVEN: 'EVEN',
};
/** Значення в порядку оголошення в схемі. */
export const PARITY_VALUES = ['ALL', 'ODD', 'EVEN'];
export const PARITY_LABELS = {
    ALL: 'Щотижня',
    ODD: 'Чисельник',
    EVEN: 'Знаменник',
};
//# sourceMappingURL=parity.js.map